import * as React from 'react';

import { CartServiceProps } from '../../types';
import { NASProductCategory } from '@websky/graphql';
import { useEveryPort } from '../../../CheckoutAdditionalService/components/EveryPortLounge/everyPort.hooks';
import ServiceSummaryDivider from '../../../ServiceSummary/components/ServiceSummaryDivider/ServiceSummaryDivider';
import ServiceSummaryOption from '../../../ServiceSummary/components/ServiceSummaryOption';
import { groupNasServices } from '../../utils';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import { capitalizeFirstLetter } from '../../../utils';
import { getNasServiceCardParams } from '../../../CheckoutAdditionalService/components/EveryPortLounge/utils';

const NasSummary: React.FC<CartServiceProps> = ({ services, travellers, flight }) => {
	const model = useEveryPort(NASProductCategory.lounge, '0'),
		data = groupNasServices(services.nas, travellers, flight.segments);

	const { t } = useTranslation(['Cart', 'Checkout']);

	const onRemoveService = (category: NASProductCategory, productId: string, travellerId: string) => {
		model.onRemoveService(productId, travellerId, category);
	};

	if (!services.nas?.services?.length) {
		return null;
	}

	if (!model.selectedSummary.passengerNames.length) {
		return null;
	}

	return (
		<>
			{data.map(data => {
				const nasData = getNasServiceCardParams(data.category);

				return (
					<ServiceSummaryDivider key={data.category}>
						<ServiceSummaryOption
							groupOption={{
								header: t(nasData.title, { ns: 'Checkout' }),
								items: data.travellers.map(traveller => ({
									id: traveller.travellerId,
									name: t('{{date}}, {{iata}}, {{travellerName}}', {
										date: format(traveller.date, 'dd.MM.yy'),
										travellerName: capitalizeFirstLetter(traveller.travellerName),
										iata: traveller.segmentIata
									}),
									price: traveller.totalPrice,
									onDelete: traveller.canBeDeleted
										? () =>
												onRemoveService(
													data.category,
													traveller.productId,
													traveller.travellerId
												)
										: null
								}))
							}}
						/>
					</ServiceSummaryDivider>
				);
			})}
		</>
	);
};

export default NasSummary;
